import React from "react";
import { useDispatch } from "react-redux";
import { set_drop_down_help } from "redux/game/action";

const TwDropdown = ({
  handle_leave_game,
  onLogout,
  toggle_dropdown,
  handle_help_click,
  isFlusterHeader,
  isDw20Header,isChartypartyHeader,isOchosLocosHeader
}) => {
  const dispatch = useDispatch();
  const handle_help = () => {
    handle_help_click();
    dispatch(set_drop_down_help(true));
  };
  return (
    <div
      className={`tw-dropdown ${
        isDw20Header
          ? "dw20-dropdown"
          : isFlusterHeader
          ? "common-dropdown" :isChartypartyHeader?"chpt-dropdown" :isOchosLocosHeader?"common-dropdown"
          : ""
      }`}
    >
      <div className="box">
        <ul>
          <li
            onClick={() => {
              toggle_dropdown();
              handle_leave_game();
            }}
          >
            Leave Game
          </li>
          <li
            onClick={() => {
              toggle_dropdown();
              handle_leave_game();
              onLogout();
            }}
          >
            Logout
          </li>
          <li
            onClick={() => {
              toggle_dropdown();
              handle_help();
            }}
          >
            Help
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TwDropdown;
